import { createSlice } from "@reduxjs/toolkit";

export const ownerSlice = createSlice({
  name: "owner",
  initialState: {
    owner: null,
  },
  reducers: {
    setOwner: (state, action) => {
      state.owner = action.payload;
    },
    clearOwner: (state) => {
      state.owner = null;
    },
  },
});

export const { setOwner, clearOwner } = ownerSlice.actions;

export default ownerSlice.reducer;
